import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { IQuestion } from "~/components/FAQ/types";
import styled, { css } from "~/styled";

import { Collapse } from "@blueprintjs/core";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";

import PaymentMethods from "./PaymentMethods";

interface IProps extends WithTranslation {
  question: IQuestion;
  open: boolean;
  onToggle: () => void;
}

interface IState {
  open: boolean;
}

const QuestionWrapper = styled.section`
  display: grid;
  grid-template-areas:
    "icon question"
    ". answer";
  grid-template-columns: auto 1fr;
  grid-column-gap: 12px;
  grid-row-gap: 6px;
`;

const QuestionHeader = styled.h4`
  grid-area: question;
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  align-self: center;
  user-select: none;
  cursor: pointer;

  @media (max-width: 375px) {
    font-size: 14px;
  }

  @media (max-width: 320px) {
    font-size: 12px;
  }
`;

const Answer = styled.div`
  grid-area: answer;

  img {
    max-width: 100%;
  }
`;

const Icon = styled(KeyboardArrowDown)<{ open: boolean }>`
  cursor: pointer;
  grid-area: icon;
  && {
    transition: transform 0.2s ease;
  }
  transform: rotate(0deg);
  ${props =>
    !props.open &&
    css`
      transform: rotate(-90deg);
    `};
`;

class Question extends React.Component<IProps, IState> {
  public state = {
    open: false
  };

  public render() {
    const {
      open,
      question: { key, question, answer }
    } = this.props;

    return (
      <QuestionWrapper>
        <Icon open={open} onClick={this.handleToggle} />

        <QuestionHeader onClick={this.handleToggle}>{question}</QuestionHeader>

        <Answer>
          <Collapse isOpen={open} keepChildrenMounted={true}>
            <div dangerouslySetInnerHTML={{ __html: answer }} />

            {key === "payment-method" && <PaymentMethods />}
          </Collapse>
        </Answer>
      </QuestionWrapper>
    );
  }

  private handleToggle = () => this.props.onToggle();
}

export default withTranslation("faq")(Question);



// WEBPACK FOOTER //
// ./src/components/FAQ/Question.tsx